import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static values = {
    url: String,
    delay: { type: Number, default: 50 },
  };

  connect() {
    if (!this.urlValue) {
      return;
    }

    this.timer = window.setTimeout(() => {
      Turbo.visit(this.urlValue);
    }, this.delayValue);
  }

  disconnect() {
    if (!this.timer) {
      return;
    }

    window.clearTimeout(this.timer);
    this.timer = null;
  }
}
